var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5.64706,
    fill: "#E9BE5C",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6777 6.10751C11.6162 6.14186 8.50293 12.1216 8.50293 12.2055C8.50293 12.2422 8.52366 12.2968 8.54899 12.3269L8.59505 12.3814L9.70273 12.393L10.8104 12.4045L9.65756 15.0283C8.94544 16.649 8.50438 17.6812 8.50382 17.7282C8.50199 17.8842 8.7038 17.9756 8.83198 17.8769C8.86052 17.855 10.3709 16.1426 12.1883 14.0717C15.8077 9.9476 15.57 10.2393 15.4347 10.0884L15.3765 10.0235L14.1259 10.012L12.8753 10.0004L14.0877 8.1653C14.8352 7.03376 15.3 6.30856 15.3 6.27375C15.3 6.24212 15.269 6.1875 15.2295 6.14968L15.1591 6.08211L13.4399 6.0828C12.2968 6.08329 11.7063 6.09156 11.6777 6.10751Z",
    fill: "#E9BE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/zap.7ef4f8ebd141cdf78616a521a1ebca68.svg";
export { ForwardRef as ReactComponent };